import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as ChangePasswordActions from '../actions/change-password.actions';
import { Action, Store } from '@ngrx/store';
import { TechnicalError } from '../../models/errors.model';
import { IEntity } from '@proximus/entity-manager';
import { ApplicationState, getSelectedMailbox } from '../../../store/reducers';
import { PasswordService } from '../../service/password.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { BrandService } from 'src/app/services/brand.service';

@Injectable()
export class ChangePasswordEffects {
  @Effect()
  changePassword$: Observable<Action> = this.actions$.pipe(
    ofType(ChangePasswordActions.ActionTypes.CHANGE_PASSWORD),
    map((action: ChangePasswordActions.ChangePasswordAction) => action.payload),
    withLatestFrom(this.store.select(getSelectedMailbox)),
    switchMap(([action, selectedMailbox]) => {
      const appBrand = this.brandService.getAppBrandValue();
      return this.passwordService.changePassword(selectedMailbox.mbxId, action, appBrand).pipe(
        map(
          (success: IEntity<any>) =>
            new ChangePasswordActions.ChangePasswordSuccessAction(),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(new ChangePasswordActions.ChangePasswordErrorAction(error.value)),
        ),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>,
    private passwordService: PasswordService,
    private readonly brandService: BrandService,
  ) {}
}
